$(document).ready(function(){




// get cart attributes start
// setTimeout(() => {
  
// $.getJSON('/cart.js', function(cart){
//    $.each(cart.attributes, function (key, value) {
//       // console.log('Key:', key);
//       // console.log('Value:', value);
//       $('.gift_cart_input').each(function(){
        
//         var currentKey = $(this).attr('name');
//         if(currentKey == key){
//            $(this).val(value);
//         }
//       });
//       var giftOrderSelectVal = $('.gift-card__select').attr('name');
//       if(giftOrderSelectVal == key && value == 'Yes, add card message'){
//         $('.gift-card__select').val(value).trigger('change');
//       }
      
//     });
// });



// }, 3000);

function giftOrderNo(){
    var Isgift = $('.gift-card__select').val()

  if (Isgift !== 'Yes, add card message') {

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        "attributes[Would you like to add a card message?]": "No thanks"
      },
      dataType: 'json',
      success: function(cart) {
        console.log(cart)
      }
    })

  }
}

// setTimeout(() => {
//   giftOrderNo();
// }, 4000);

$.getJSON('/cart.js', function(cart){
  // alert(cart.item_count);
  if(cart.item_count == 0){
    
      removeGiftAttributes();
    
    
  }
});

// get cart attributes end

// function remove cart attributes start
function removeGiftAttributes() {

  var attributesObj = {};

  $('.gift_cart_input').each(function () {
    var key = $(this).attr('name');
    if (key) {
      attributesObj[key] = '';
    }
  });

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      attributes: attributesObj
    },
    dataType: 'json',
    success: function (cart) {
      // console.log('Gift attributes removed', cart.attributes);
    }
  });
}
// removeGiftAttributes();
// function remove cart attributes end
// Gift cart select start
$(document).on('change', '.gift-card__select', function(){
    var gift_select_val = $(this).val();
    //  alert(gift_select_val);
    if(gift_select_val=="Yes, add card message"){
        $('.gift-card__conditional').slideDown();
        $('.custom_checkout_btn').removeClass('hide_cart_btn');
        $('.cart__checkout-button').addClass('hide_cart_btn');
    }else {
        $('.gift-card__conditional').slideUp();
        removeGiftAttributes();
        $('.gift_cart_input').val('');
        $('.custom_checkout_btn').addClass('hide_cart_btn');
        $('.cart__checkout-button').removeClass('hide_cart_btn');
        var gift_select_val = $(this).val('No thanks');
        setTimeout(() => {
          giftOrderNo();
        }, 1000);

    }
});

// setTimeout(function(){
   var giftCardSelectVal = $('.gift-card__select').val();
   
   if(giftCardSelectVal !== ''){
      // alert(giftCardSelectVal);
      window.location.reload();
   }
// },1000);

// Gift cart select end

// Gift field validations start
var formClick = true;

function checkEmptyFields() {
  formClick = true;
  $('.gift_cart_input_req').next().hide();
  $('.gift_cart_input_req').each(function () {
    if ($(this).val().trim() === '') {
      formClick = false;
      var errorEl = $(this).next();
      errorEl.show();
      $('html, body').animate({
        scrollTop: $(this).offset().top - 170
        
      }, 600);
      $(this).focus();
      return false;
    }
  });
}
$(document).on('keyup', '.gift_cart_input_req', function(){
  if($(this) !== ''){
    $(this).next().hide();
  }
});
// Gift field validations end

// function add cart attributes start
function addCartAttributes(){
    var attributesObj = {};

  $('.gift_cart_input').each(function () {
    var key = $(this).attr('name');
    var value = $(this).val();

    if (key && value) {
      attributesObj[key] = value;
    }
  });

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      attributes: attributesObj
    },
    dataType: 'json',
    success: function (cart) {
      checkEmptyFields();
      if (formClick === true) {
          $('#checkout').trigger('click');
        }
    }
  });
}
// function add cart attributes end


// custom checkout button start
$(document).on('click', '.custom_checkout_btn', function (e) {
  var customCheckBtn = $(this);
  e.preventDefault();
if ($('.gift-card__select').val() === '') {
  checkEmptyFields();
  if (formClick === true) {
      addCartAttributes();
      $('#checkout').trigger('click');
    }
    
  }
  else {
    if ($('.gift-card__select').val() === 'Yes, add card message') {
      // alert("clicked to yes")
      checkEmptyFields();
      if (formClick === true) {
          addCartAttributes();
          customCheckBtn.addClass('lodaing');
          setTimeout(function(){
            $('#checkout').trigger('click');
            customCheckBtn.removeClass('lodaing');
          },2000)
          
        }
        
      }
  }
});
// custom checkout button end


});
